import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-delete-dialog',
  templateUrl: './delete-dialog.component.html',
  styleUrls: ['./delete-dialog.component.scss']
})
export class DeleteDialogComponent implements OnInit {

  @Input() public headingTitle: string = 'Delete';
  @Input() public title: string = '';
  @Input() public message: string = '';
  @Input() public deleteItem: any = null;
  @Input() public confirmButtonLabel: string = 'Yes';
  @Input() public cancelButtonLabel: string = 'No';
  @Output() deletePopupEmit: EventEmitter<any> = new EventEmitter();

  constructor(public activeModal: NgbActiveModal) { }

  ngOnInit() {
    if (!this.headingTitle) {
      this.headingTitle = 'Delete';
    }
  }

  delete() {
    this.deletePopupEmit.emit(this.deleteItem);
    this.activeModal.close(this.deleteItem);
  }

  closeDialog() {
    this.deletePopupEmit.emit(null);
    this.activeModal.dismiss(null);
  }
}
